import { useTranslation } from "react-i18next";
import * as Yup from "yup";

import { enumValidation } from "@configs";

export const YupTheme = () => {
    //page hook
    const { t } = useTranslation();

    return {
        theme_color_code: Yup.string()
            .required(
                t("validation.required", {
                    name: t("page.theme"),
                })
            )
            .max(
                enumValidation.MAX_TITLE_INPUT,
                t("validation.max", {
                    name: t("page.theme"),
                    number: enumValidation.MAX_TITLE_INPUT,
                })
            ),
    };
};
